/**
 * Represents the reasons a post can be rejected
 */
export enum PostDisabledReason {
  LENGTH,
  CONTENT,
}
